<template>
	<div>
		<page-header :title="title"></page-header>
		<form @submit.prevent="gravar">
			<div class="modal-body">
				<div class="form-horizontal">
					<vue-element-loading :active="isActive" spinner="bar-fade-scale" color="#428BCA"></vue-element-loading>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">
							Ano
						</label>
						<div class="col-sm-5">
							<the-mask
								class="form-control"
								type="text"
								name="ano"
								:mask="['####']"
								:masked="false"
								v-model="form.ano"
								placeholder="Ex.: 2024"
							/>
							<span class="help-block" style="font-size: 12px; color: #888;">Somente números (4 dígitos). Aparece antes do título no site.</span>
						</div>
					</div>
					<input-form-text textInput="Título" :required="true" v-model="form.titulo"
						:value="form.titulo"></input-form-text>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">
							Selecione
						</label>
						<div class="col-sm-5">
							<div class="radio">
								<label>
									<input name="form-field-radio" type="radio" class="ace" data-enpassusermodified="yes" value="1" v-model="select">
									<span class="lbl"> Arquivo</span>
								</label>
							</div>
							<div class="radio">
								<label>
									<input name="form-field-radio" type="radio" class="ace" data-enpassusermodified="yes" value="2" v-model="select">
									<span class="lbl"> Link</span>
								</label>
							</div>
						</div>
					</div>
					<div v-if="select == 2">
						<input-form-text textInput="URL" v-model="form.url"
							:value="form.url"></input-form-text>
					</div>
					<div class="form-group" v-else>
						<label class="col-sm-3 control-label no-padding-right"></label>
						<div class="col-sm-5">
							<file-upload v-if="!allFiles.length" ref="fupload" :url="'/v1/legislacao/upload'" :id="null"
								:label="'PDF até 10 MB'" :multiple="false" texto="Enviar Arquivos" accept=".pdf"
								:isFile="true"></file-upload>
							<items-edit v-else :files="allFiles" url="/v1/legislacao/upload" id="id"
								:isFile="true"></items-edit>
						</div>
					</div>
					<div class="form-group">
						<select-form v-model="form.ativo" :value="form.ativo" name="Ativo" url="/arquivos" id="id"
							titulo="nome" layout="true" optionText="Selecione" required="true"></select-form>
					</div>
				</div>
			</div>
			<footer-button :disabled="isActive"></footer-button>
		</form>
	</div>
</template>
	
<script>
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'
import fileUpload from '@/components/form/file-upload/Index'
import ItemsEdit from '@/components/form/file-upload/ItemsEdit'
import { TheMask } from 'vue-the-mask'

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading,
		fileUpload,
		ItemsEdit,
		TheMask
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Arquivos',
			form: {
				titulo: '',
				ano: '',
				legislacao_categoria_id: '',
				url: '',
				ativo: '1'
			},
			allFiles: [],
			isActiveBtn: false,
			isActive: false,
			select: 1
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		buildSaveBody() {
			const body = { ...this.form }
			const u = (body.url || '').trim()
			// Modo arquivo: nunca enviar url (campo oculto fica '').
			if (String(this.select) === '1') {
				delete body.url
				return body
			}
			// Modo link: não enviar url vazia (preserva o que está no banco).
			if (!u) {
				delete body.url
			}
			return body
		},
		async gravar() {
			this.isActive = true
			const body = this.buildSaveBody()
			//this.setVersion()
			if (this.$route.params.cat) {
				const resp = await req(`/v1/legislacao/categorias/${this.$route.params.id}/${this.$route.params.cat}`, 'put', body).catch(response => {
					'error: ' + response
					erro()
				})
				this.isActive = false
				if(this.$refs.fupload) {
					const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
					const m = tb[0]
					resp.folder = this.form.folder
					await m.uploadAll(resp)
				}
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push(`/servicos/legislacao/${this.$route.params.id}`)
			} else {
				const resp = await req(`/v1/legislacao/categorias/${this.$route.params.id}`, 'post', body).catch(response => {
					'error: ' + response
					erro()
				})
				this.isActive = false
				if(this.$refs.fupload) {
					const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
					const m = tb[0]
					await m.uploadAll(resp)
				}
				sucesso('Atualizado...')
				this.$router.push(`/servicos/legislacao/${this.$route.params.id}`)
				this.getLogsTotal(this.user.id)
			}
			this.isActive = false
		},
		async setVersion() {
			const dados = await req('/versao/1', 'put', {
				title: Date.now()
			})
			dados
		},
		async getDados() {
			const resp = await req(`/v1/legislacao/categorias/${this.$route.params.id}/${this.$route.params.cat}`).catch(response => {
				'error: ' + response
				erro()
			})
			this.form.titulo = resp.titulo
			this.form.ano = resp.ano != null && resp.ano !== '' ? String(resp.ano) : ''
			// Valor bruto no banco (path ou URL externa); evita confundir PDF interno com "link".
			const raw = (resp.url_armazenamento != null && resp.url_armazenamento !== '')
				? String(resp.url_armazenamento).trim()
				: ''
			if (raw && /^https?:\/\//i.test(raw)) {
				this.select = '2'
				this.form.url = raw
				this.allFiles = []
			} else if (raw) {
				this.select = '1'
				this.form.url = ''
				this.allFiles = resp.url ? [{ id: this.$route.params.arq, files: resp.url }] : []
			} else {
				this.select = '1'
				this.form.url = ''
				this.allFiles = []
			}
			this.form.legislacao_categoria_id = resp.legislacao_categoria_id
			this.form.ativo = resp.ativo
			this.isActive = false
		},
		verifPermissao() {
			if (this.$route.params.arq) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		},
		async getDadosGeral() {
			const dados = await req(`/v1/legislacao/${this.$route.params.id}`)
			this.$parent.$parent.$children.filter(i => i.$refs.menuSelecionado)[0].$refs.menuSelecionado[0].to = `/servicos/legislacao/${this.$route.params.id}`
			this.$parent.$parent.$children.filter(i => i.$refs.menuSelecionado)[0].$refs.menuSelecionado[0].$el.textContent = dados.titulo
		},
	},
	mounted() {
		this.verifPermissao()
		this.getDadosGeral()
		if (this.$route.params.cat) {
			this.isActive = true
			this.getDados()
		} else {
			this.form.legislacao_categoria_id = this.$route.params.id
		}
	}
}
</script>
	
<style lang="stylus" scoped>
	
	</style>
	